import { connect } from 'react-redux'
import PupilEntry from './pupil-entry'
import {
  getPupil,
  getPupilUpdatingStatus,
  getPupilDeletingStatus,
  getPupilAddingToGroupStatus,
  getPupilRemovingFromGroupStatus,
  getPupilIncrementingAgeGroupStatus
} from '../../../stores/pupils/pupils.selectors'
import { setPupilSelectStatus } from '../pupils-component-redux/pupils-component.actions'
import { isPupilSelected } from '../pupils-component-redux/pupils-component.selectors'

const mapStateToProps = (state, { id }) => {
  const pupil = getPupil(state, id)
  return {
    pending:
      getPupilUpdatingStatus(state, id).pending ||
      getPupilDeletingStatus(state, id).pending ||
      getPupilAddingToGroupStatus(state, id).pending ||
      getPupilRemovingFromGroupStatus(state, id).pending ||
      getPupilIncrementingAgeGroupStatus(state, id).pending,
    selected: isPupilSelected(state, id),
    name: pupil.account.full_name,
    displayName: pupil.account.display_name,
    age: pupil.year_group,
    groups: pupil.groups,
    permission: pupil.policy.can_publish,
    passcode: pupil.passcode,
    works: pupil.all_works_count
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onChange: e => dispatch(setPupilSelectStatus(ownProps.id, e.target.checked))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PupilEntry)
